/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_pass': {
    width: 31,
    height: 18,
    viewBox: '0 0 31 18',
    data: '<path pid="0" d="M25.86 8.854l4.242-7.071.354 11.667-12.374.353 7.778-4.95zm0 0l-.354-.354C19.844 2.837 10.41 2.084 4.747 7.747A14.455 14.455 0 0 0 .5 18"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_pass.js